/* @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import Tooltip from '@atlaskit/tooltip';
import { IconButton } from '@atlaskit/button/new';
import CopyIcon from '@atlaskit/icon/glyph/copy';
import messages from './messages';
/* *
 * TODO: AIFOLLOWUP
 * When playwright has cross browser support, make sure to test it:
 * ./__tests__/playwright/copy-paste.ai-test.ts
 *
 * TODO: AIFOLLOWUP
 * This needs extensive manual cross-browser testing as part of EAP.
 * */
export const CopyIconButton = ({
  onClick,
  tabIndex
}) => {
  const {
    formatMessage
  } = useIntl();
  const [tooltip, setTooltip] = React.useState(formatMessage(messages.copy));
  const updateTooltip = React.useRef();
  const handleOnClick = React.useCallback(event => {
    onClick(event);
    setTooltip(formatMessage(messages.copiedToClipboard));
  }, [onClick, formatMessage]);
  const resetTooltip = React.useCallback(() => setTooltip(formatMessage(messages.copy)), [formatMessage]);
  React.useLayoutEffect(() => {
    var _updateTooltip$curren;
    (_updateTooltip$curren = updateTooltip.current) === null || _updateTooltip$curren === void 0 ? void 0 : _updateTooltip$curren.call(updateTooltip);
  }, [tooltip]);
  return jsx(Tooltip, {
    content: ({
      update
    }) => {
      updateTooltip.current = update;
      return tooltip;
    },
    position: "top",
    onHide: resetTooltip
  }, jsx(IconButton, {
    testId: "copy-response-button",
    type: "button",
    onClick: handleOnClick,
    icon: CopyIcon,
    label: tooltip,
    appearance: "default",
    tabIndex: tabIndex
  }));
};